import wx from 'weixin-js-sdk';
import axios from 'axios';
import state from '../../store/state';

function wxRegister(callback) {
    let shareParam = {
        url: window.location.href.split("#")[0]
    };
    /*获取微信config */
    axios({
        method: 'get',
        url: state.ip + "users/get_wechat_config",
        params: shareParam,
        cache: false,
    }).then(function (res) {
        // console.log(res); //处理成功的函数 相当于success
        if (res.status == 200) {
            let appId = res.data.msg.appId;
            let nonceStr = res.data.msg.nonceStr;
            let signature = res.data.msg.signature;
            let timestamp = res.data.msg.timestamp;
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appId, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: nonceStr, // 必填，生成签名的随机串
                signature: signature, // 必填，签名，见附录1
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'openLocation',
                    'previewImage'
                ]
            });
        }
    }).catch(function (error) {
        console.log(error); //错误处理 相当于error
    });

    wx.ready(function () {
        // 如果需要定制ready回调方法
        if (callback) {
            callback();
        }
    })
};

function ShareTimeline(opstion) {
    //分享给朋友
    if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData({
            title: opstion.title, // 分享标题
            desc: opstion.desc, // 分享描述
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            success: function success() {
                opstion.success();
            },
            cancel: function cancel() {
                opstion.error();
            }
        });
    } else {
        wx.onMenuShareAppMessage({
            title: opstion.title, // 分享标题
            desc: opstion.desc, // 分享描述
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            success: function success() {
                opstion.success();
            },
            cancel: function cancel() {
                opstion.error();
            }
        });
    };
    if (wx.updateTimelineShareData) {
        wx.updateTimelineShareData({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            success: function success() {
                opstion.success();
            },
            cancel: function cancel() {
                opstion.error();
            }
        })
    } else {
        wx.onMenuShareTimeline({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            success: function success() {
                opstion.success();
            },
            cancel: function cancel() {
                opstion.error();
            }
        });
    };
}
//微信地址导航
function openLocation(opstion) {
    wx.openLocation({
        latitude: 30.571896, // 纬度，浮点数，范围为90 ~ -90
        longitude: 114.033569, // 经度，浮点数，范围为180 ~ -180。
        name: opstion.name, // 位置名
        address: opstion.address, // 地址详情说明
        scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
}
//微信图片预览
function previewImage(imgList) {
    wx.previewImage({
        current: imgList.img, // 当前显示图片的http链接
        urls: imgList.imgs // 需要预览的图片http链接列表
    });
}

// 暴露出这些属性和方法
export default {
    wxRegister,
    ShareTimeline,
    openLocation,
    previewImage,
}


// WEBPACK FOOTER //
// ./src/assets/publicJS/WechatShare.js